import { useEffect, useRef } from 'react';

// import { useKey } from '../../useKey';

import './search.scss';

function Search({ onQuery, query }) {
  const inputEl = useRef(null);

  useEffect(function () {
    if (document.activeElement === inputEl.current) return;
    inputEl.current.focus();
    // onQuery('');
  }, []);

  return (
    <input
      ref={inputEl}
      className='search'
      type='text'
      placeholder='Search movies...'
      value={query}
      onChange={(e) => onQuery(e.target.value)}
    />
  );
}

export default Search;
